import React, { useState } from 'react';
import { Text, AccentButton } from '../../ui';
import { Brain, AlertTriangle } from 'lucide-react';

interface DistractionStageProps {
  onComplete: () => void;
}

const mathProblems = [
  { problem: "12 × 8", answer: "96" },
  { problem: "156 - 89", answer: "67" },
  { problem: "15 + 27", answer: "42" }
];

export const DistractionStage: React.FC<DistractionStageProps> = ({ onComplete }) => {
  const [answers, setAnswers] = useState<string[]>(["", "", ""]);
  const [error, setError] = useState("");

  const handleAnswerChange = (index: number, value: string) => {
    const newAnswers = [...answers];
    newAnswers[index] = value;
    setAnswers(newAnswers);
    setError("");
  };

  const checkAnswers = () => {
    const allCorrect = mathProblems.every((problem, index) => 
      answers[index].trim() === problem.answer
    );

    if (allCorrect) {
      onComplete();
    } else {
      setError("Please check your answers. All must be correct to continue.");
    }
  };

  return (
    <div className="bg-white/90 backdrop-blur-sm rounded-xl p-6 border border-gray-100">
      <div className="flex items-center gap-3 mb-4">
        <Brain className="w-5 h-5 text-orange-500" />
        <Text className="font-medium">
          Quick Math Challenge
        </Text>
      </div>

      <div className="space-y-6">
        <Text className="text-gray-700">
          Before we continue, please solve these math problems.
        </Text>

        <div className="space-y-4">
          {mathProblems.map((problem, index) => (
            <div 
              key={index}
              className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl"
            >
              <Text className="font-medium text-gray-800 w-24">
                {problem.problem} =
              </Text>
              <input
                type="text"
                value={answers[index]}
                onChange={(e) => handleAnswerChange(index, e.target.value)}
                className="border-2 border-gray-200 rounded-lg px-3 py-2 w-24
                  focus:outline-none focus:border-orange-500 transition-colors"
                placeholder="Answer"
              />
            </div>
          ))}
        </div>

        {error && (
          <div className="flex items-center gap-2 text-red-500">
            <AlertTriangle className="w-5 h-5" />
            <Text>{error}</Text>
          </div>
        )}

        <div className="flex justify-center mt-6">
          <AccentButton 
            onClick={checkAnswers}
          >
            Check Answers & Continue
          </AccentButton>
        </div>
      </div>
    </div>
  );
}; 